import _ from 'underscore';
import { BaseValidator } from './base-validator';

export class EnumValidator extends BaseValidator {
  constructor(propertySchema) {
    super(propertySchema);

    this.enum = propertySchema.enum;
  }

  get requiredField() {
    return 'enum';
  }

  internalValidate(propertyValue) {
    return _.contains(this.enum, propertyValue);
  }
}
